import React from 'react'
import { Modal } from 'react-bootstrap'
import axios from '../../../constents/axios'

const DeleteSelectedTest = ({show,handleClose,ids,onSuccess}) => {
    console.log("ids",ids);

    const handleDelete = async () => {
        try {
            const response = await axios.post(`/tests/deleteSelectedTest`,{testIds:ids}
            ,{
                headers: {
                    'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa` // Replace with your actual token
                }
            }
            )
            console.log(response)
            handleClose()
            onSuccess(1)
        } catch (error) {
            console.log(error)
        }
    }
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Delete Selected Tests</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Are you sure you want to delete this selected test?</p>
        </Modal.Body>
        <Modal.Footer>
            <button className='btn btn-danger' onClick={handleDelete}>Yes</button>
        </Modal.Footer>
    </Modal>
  )
}

export default DeleteSelectedTest